import * as changeCase from "change-case";
import { useFormContext } from "react-hook-form";
import { FormControl, FormDescription, FormField, FormItem, FormLabel } from "@patient-watch/ui/form";
import { Switch as SwitchElement } from "@patient-watch/ui/switch";
import { cn } from "@patient-watch/ui";

interface Props {
    name: string;
    label: string;
    description?: string;
    autoFocus?: boolean;
    className?: string;
    disabled?: boolean;
}

const Switch = ({ name, label, description, autoFocus = false, className, disabled = false }: Props) => {
    const form = useFormContext();
    return (
        <FormField
            control={form.control}
            name={name}
            render={({ field }) => (
                <FormItem className={cn("flex flex-row justify-between items-center", className)}>
                    <div className="space-y-0.5">
                        <FormLabel className="text-lg">{label}</FormLabel>
                        {description && <FormDescription>{description}</FormDescription>}
                    </div>
                    <FormControl>
                        <SwitchElement
                            autoFocus={autoFocus}
                            data-testid={`${changeCase.kebabCase(name)}-switch`}
                            checked={field.value}
                            onCheckedChange={field.onChange}
                            disabled={disabled}
                        />
                    </FormControl>
                </FormItem>
            )}
        />
    );
};

export default Switch;
